import React from 'react';
import PropTypes from 'prop-types';
import Num from '../../../common/Num';
import { MoneyFitSmall } from './MoneyFit';

const CountAndAmountBlock = ({ title, count, amount, automationIdPart }) => (
  <div className="c-report-total-calculation u-pb u-pt">
    <div className="c-report-stat c-report-stat--medium u-mb--">
      <Num automationId={`text:${automationIdPart}:count`}>{count}</Num>
    </div>
    <div className="c-report-label">{title}</div>
    <div className="c-report-stat c-report-stat--small u-type--normal u-co-red">
      <MoneyFitSmall automationId={`text:${automationIdPart}:amount`}>{amount}</MoneyFitSmall>
    </div>
  </div>
);

CountAndAmountBlock.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  automationIdPart: PropTypes.string,
};

CountAndAmountBlock.defaultProps = {
  automationIdPart: null,
};

export default CountAndAmountBlock;
